import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_complete.svg'
import _imports_1 from '@/assets/img/img_entry_career_complete.svg'


const _withScopeId = n => (_pushScopeId("data-v-bf6a612a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"entry_career_complete_img\" src=\"" + _imports_0 + "\" alt=\"\" data-v-bf6a612a><p class=\"entry_career_complete_title\" data-v-bf6a612a>ご入力ありがとうございました</p><p class=\"entry_career_complete_text\" data-v-bf6a612a> キャリアシートの入力はこれで完了です。 <br data-v-bf6a612a> 面談・相談が完了したあと、あなたにマッチした求人をご紹介します。 <br data-v-bf6a612a> 面談予約をお取りください。 </p><div class=\"entry_career_complete_flow\" data-v-bf6a612a><p class=\"entry_career_complete_flow_title\" data-v-bf6a612a>応募までの流れ</p><img class=\"entry_career_complete_flow_img\" src=\"" + _imports_1 + "\" alt=\"\" data-v-bf6a612a></div>", 4)
const _hoisted_6 = { class: "entry_career_complete_button_appointment" }
const _hoisted_7 = { class: "entry_career_complete_button_home" }

import { useRouter } from 'vue-router';
import BaseButton from '@/components/BaseButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteView',
  setup(__props) {

const router = useRouter();
const transitionAppointment = () => {
  router.push({ name: 'd00' });
};
const transitionHome = () => {
  router.push({ name: 'f00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseButton, {
          onClick: transitionAppointment,
          theme: "primary",
          type: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("面談予約へ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseButton, {
          onClick: transitionHome,
          theme: "secondary",
          type: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("あとで予約する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})